import { initFirebase } from "./firebase";
import { onAuthStateChanged } from "firebase/auth";

export async function getAuthToken(): Promise<string | false> {
  try {
    const auth = await initFirebase();

    const user = auth.currentUser;

    if (user) {
      return await user.getIdToken();
    }

    // If currentUser is null, wait for auth state to change
    return new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        unsubscribe();

        if (user) {
          const token = await user.getIdToken();
          resolve(token);
        } else {
          resolve(false);
        }
      });
    });
  } catch (error) {
    return false;
  }
}
